import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { ISnapshotSignRequest, SnapshotSignRequest } from "@/models/snapshot-sign-request.entity";

export const SnapshotSignRequestDataAccessLayer =
  new (class extends AbstractLocalDataAccessLayer<ISnapshotSignRequest> {
    protected mapEntity(entity: ISnapshotSignRequest): ISnapshotSignRequest {
      return new SnapshotSignRequest(entity);
    }

    getIdentifier(entity: ISnapshotSignRequest): string {
      return entity.id;
    }
  })();
